import { PackagingMaterialBE } from '../../packaging-material/shared/packaging-material.model';
import { PackagingCodeBe } from '../../packaging-code/shared/packaging-code.model';
import { PictureBe } from '../../image-library/shared/image-model';


export class DistributionUnitBE {
    Id: number = -1;
    StackableDu: boolean = false;
    StatusDescription: string = "";
    StatusId: number = 1;
    Version: number = 1;
    IssuerUserId: string = "";
    IssuerName: string = "";
    IssuerEmail:string="";
    IssuerDepartment: string = "";
    IssueDate: Date = new Date();
    Remarks: string = "";
    UnitHeight: number = 0;
    UnitLength: number = 0;
    UnitWidth: number = 0;
    UnitVolume: number = 0;
    GrossWeight: number = 0;
    NetWeight: number = 0;
    Material: PackagingMaterialBE = new PackagingMaterialBE;
    Pictures: Array<PictureBe> = [];
    DUMaterial: Array<DUAdditionalInfoBe> = [];
    OuterUnit: Array<PackagingCodeBe> = [];
    OuterUnitQuantity: number = 0;
    OuterUnitString: string = "";
    InnerUnit: Array<PackagingCodeBe> = [];
    InnerUnitQuantity: number = 0;
    InnerUnitString: string = null;
    RemarksContent: string = "";
    UpdatedIssuer: string= "";
    UpdatedDate: Date = new Date();
}

export class DUAdditionalInfoBe {
    Id: number = -1;
    Description: string = "";
    MHNo: string = "";
    Quantity: number = 0;
    Weight: number = 0;
}

export class DuData {
    GrossWeight: number = 0;
    NetWeight: number = 0;
}

export class DistributionUnitSearch {
    SearchMHNo: string = "";
    SearchMHDescription: string = "";
    StatusListId: number = 1;
    SearchIssuerUserId: string = "";
    CreateDateFrom: string = "";
    CreateDateTo: string = "";
    IncludeDateSpansInSearch: boolean = false;
    SearchPkgCode: string = "";
    NumToSkip: number = 0;
    MainStore: string = "";
}

export class DistributionUnitListBE {
    Id: number = -1;
    MHNo: string = "";
    MHDescription: string = "";
    IssuerUserId: string = "";
    IssueDate: string = "";
    PkgCode: string = "";
    StatusDescription: string = "";
}


// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/distribution-unit/shared/distribution-unit.model.ts